export const UNMUTE_WS_URL = 'wss://0pcx2scf6dxw5z-8998.proxy.runpod.net/v1/realtime';
export const TEXT_WS_URL = 'wss://0pcx2scf6dxw5z-8998.proxy.runpod.net/ws/text';

export const SOPHIE_STORAGE_KEY = 'sophie_assistant';

export const MAX_CONVERSATION_HISTORY = 20;
